import { render, staticRenderFns } from "./ProductPurchasesListTable.vue?vue&type=template&id=3d510215&scoped=true&"
import script from "./ProductPurchasesListTable.vue?vue&type=script&lang=js&"
export * from "./ProductPurchasesListTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductPurchasesListTable.vue?vue&type=style&index=0&id=3d510215&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d510215",
  null
  
)

export default component.exports